import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { generateCalendarButtonURL } from 'components/Booking-new/utils/steps/summary';
import { StyledLink } from './styles';
const DEFAULT_FILE_NAME = 'download.ics';

const AddToCalendar = ({ event, label, type }) => {
  const [buttonURL, setButtonURL] = useState('');
  const [isIE, setIsIE] = useState(false);

  useEffect(() => {
    const isInternetExplorer = window?.navigator?.msSaveOrOpenBlob && window?.Blob;
    const URL = generateCalendarButtonURL(event, type, isInternetExplorer);

    setIsIE(isInternetExplorer);
    setButtonURL(URL);
  }, []);

  const handleOnClick = e => {
    if (type === 'default') {
      e.preventDefault();

      const filename = DEFAULT_FILE_NAME;
      const blob = new Blob([buttonURL], { type: 'text/calendar;charset=utf-8' });

      if (isIE) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
        return;
      }

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <StyledLink className="add-to-calendar" onClick={handleOnClick} href={buttonURL} target="_blank" rel="noreferrer">
      {label}
    </StyledLink>
  );
};

AddToCalendar.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    url: PropTypes.string,
    location: PropTypes.string.isRequired,
    startTime: PropTypes.string.isRequired,
    endTime: PropTypes.string.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['google', 'default']),
};

export default AddToCalendar;
